module.exports = __webpack_public_path__ + "img/hk_lv1_active@2x.f1149d9e.png";